import Footer from "../Footer/footer";
import { FirstSection, SecondSection } from "./commonProjectPages";
import ThirdSection from "./commonProjectPages";
import { ClientFTdecor } from "../Data/clientsData";

function FtDecor() {
  return (
    <>
      <div className="container-fluid-eachProject">
        <FirstSection
          projectTitle={ClientFTdecor.companyName}
          year={ClientFTdecor.year}
          projectType={ClientFTdecor.projectType}
          clientCompanyName={ClientFTdecor.clientName}
          projectVideo1={ClientFTdecor.video1}
          //  projectVideoReel1={ClientFTdecor.reel1}
          viemoIframe={ClientFTdecor.vimeo}
          descriptionFirstSection={ClientFTdecor.disc1}
        />
        <SecondSection
          secondSectionImag1={ClientFTdecor.beforeImage}
          secondSectionImag2={ClientFTdecor.afterImage}
          secondSectionDisc1={ClientFTdecor.beforetext}
          secondSectionDisc2={ClientFTdecor.afterText}
        />

        <ThirdSection
          mobileVideo1={ClientFTdecor.mobileVideo}
          videoTitle={ClientFTdecor.projectTitle}
          thirdDisc={ClientFTdecor.disc2}
          button1Name="Visit Client’s Social Media"
          button2Name="Contact Us"
          btn1Link={ClientFTdecor.clientSocialMedia}
          btn2Link={"/contact"}
        />
        {/*
        <FourthSection
          clientPhoto={Client1.clientPhoto}
          clientName={Client1.clientName}
          clientCompany={Client1.companyName}
          clientTextReview={Client1.reviewText}
          clientVideoReview={Client1.reviewVideo}
        /> */}
      </div>

      <Footer />
    </>
  );
}

export default FtDecor;
